import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useHistory,
} from "react-router-dom";
import MainPage from "./Pages/MainPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import "./i18n";
import Login from "./Pages/Login";
import BarberMainPage from "./Pages/BarberMainPage";
import AdminPage from "./Pages/AdminPage";
import LandingPage from "./Pages/LandingPage";
import AllCategories from "./Pages/BarberMainPageComps/AllCategories";
import ClientAppointments from "./Pages/MainPageComps/ClientAppointments";
import AdminMainPage from "./Pages/AdminComps/AdminMainPage";

//for local
//export const MyDomain = "http://10.0.0.4/";
//export const MyDomain = "http://172.20.10.11/";
export const MyDomain =
  "https://neholtorem.happymushroom-066fb8ce.westeurope.azurecontainerapps.io/";

//for cloud
const App = () => {
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("he");
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [canRender, setCanRender] = useState(false);

  const history = useHistory();

  useEffect(() => {
    changeLanguage(lang);

    // Check BEFORE rendering
    const normalizedPath = window.location.pathname.toLowerCase();
    const currentPath = window.location.pathname;

    if (currentPath !== normalizedPath) {
      // Redirect without rendering
      window.location.replace(normalizedPath);
    } else {
      // Path is already lowercase, safe to render
      setCanRender(true);
    }
  }, [lang]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Don't render until we've checked the path
  if (!canRender) {
    return null; // or return a loading spinner
  }

  return (
    <div
      style={{
        justifyContent: "center",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <Switch>
        <Route exact path="/" component={MainPage} />
        <Route
          exact
          path="/barber-main-page/:BarberPhoneNumber"
          component={BarberMainPage}
        />
        <Route exact path="/login" component={Login} />
        <Route exact path="/admin-page" component={AdminPage} />
        <Route exact path="/landing-page" component={LandingPage} />
        <Route
          exact
          path="/client-appointments"
          component={ClientAppointments}
        />

        <Route
          exact
          path="/allcategories/:CategoryName"
          render={({ match }) => (
            <AllCategories
              key={match.params.CategoryName}
              CategoryName={match.params.CategoryName}
            />
          )}
        />
        <Route exact path="/admin-main-page" component={AdminMainPage} />
      </Switch>
    </div>
  );
};

export default App;
